jQuery(document).ready(function($) {
    // On hover, show dropdown menu
    $('.menu-item-has-children').hover(function() {
        $(this).children('.dropdown-menu').stop(true, true).slideDown(200);
    }, function() {
        $(this).children('.dropdown-menu').stop(true, true).slideUp(200);
    });



$('#menu-item-dropdown-291').click(function() {
   window.location = "/find-your-state"
});

  function adjustWidth(input) {
    input.style.width = "200px"; // Set width to a specified value whenever there's input
  }


});
